import Button from '@mui/material/Button';
import Card from 'components/shared/Card';
import React from 'react';
import { ChapterCustomer } from 'store/types/Chapter';
import { CommunityLink, JoinedCommunity } from 'store/types/Community';
import { getStringValue, STRING_DATE_FORMAT } from 'util/Format';

import styles from './CommunityInfoSection.module.scss';

interface CommunityInfoSectionProps {
  data: JoinedCommunity | ChapterCustomer;
}

const isChapterCustomer = (data: JoinedCommunity | ChapterCustomer): data is ChapterCustomer => {
  return (data as ChapterCustomer).customer !== undefined;
};

const CommunityInfoSection: React.FunctionComponent<CommunityInfoSectionProps> = ({ data }) => {
  let role: string | undefined;
  let startDate: string | undefined;
  let description: string | undefined;
  let email: string | undefined;
  let links: CommunityLink[] | undefined;

  if (isChapterCustomer(data)) {
    role = data.role.name;
    startDate = data.startDate?.toString();
    description = data.chapter.purpose;
    email = '';
    links = [];
  } else {
    role = data.member.role;
    startDate = data.member.startDate;
    description = data.description;
    email = data.email;
    links = data.communityLinks ?? [];
  }

  return (
    <Card bordered={true}>
      <section>
        <div className={styles.row}>
          <span className={styles.label}>{'About:'}</span>
          <span className={styles.value}>{description}</span>
        </div>
        {email && (
          <div className={styles.row}>
            <span className={styles.label}>{'Email:'}</span>
            <span className={styles.value}>{email}</span>
          </div>
        )}
        <div className={styles.row}>
          <span className={styles.label}>{'Role:'}</span>
          <span className={styles.value}>{role}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>{'Joined:'}</span>
          <span className={styles.value}>{getStringValue(startDate, STRING_DATE_FORMAT)}</span>
        </div>
        {links?.length > 0 && (
          <div className={styles.row} style={{ display: 'block' }}>
            <div style={{ marginBottom: '8px' }}>
              <span className={`${styles.label} ${styles.quickLinkLabel}`}>{'Quick Links:'}</span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {links
                .filter((link) => !!link.link)
                .map((link) => (
                  <Button
                    key={link.id ?? `${link.name ?? 'community'}-${link.link ?? 'link'}`}
                    component={'a'}
                    variant={'contained'}
                    color={'primary'}
                    href={link.link as string}
                    target={'_blank'}
                    rel={'noreferrer'}
                    size={'small'}
                  >
                    {link.name || 'Visit'}
                  </Button>
                ))}
            </div>
          </div>
        )}
      </section>
    </Card>
  );
};
export default CommunityInfoSection;
